// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"ce625dd9","305":"9899b9c1","331":"615c862e","338":"1d41a30a","422":"25fe757d","453":"ad574d67","493":"3a0fc4c6","960":"609f18b7"}[chunkId] + ".chunk.js";
};